import {Component, Inject, Input, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {GfxStoreService} from '../../services/gfx.store.service';
import {timer} from 'rxjs';
import {take} from 'rxjs/operators';
@Component({
    selector: 'app-err-view',
    templateUrl: './err-view.component.html',
    styleUrls: ['./err-view.component.css']
})
export class ErrViewComponent implements OnInit {

    @Input() httpRspMessg: any;
    isInstanceErrorResp = false;
    isErrorType = false;

    constructor(public modal: NgbActiveModal) {

    }


    async ngOnInit(): Promise<void> { 
        if (this.httpRspMessg instanceof HttpErrorResponse) {
            this.isInstanceErrorResp = true;
        }
        if (this.httpRspMessg instanceof Error) {
            this.isErrorType = true;
        }

        await timer(500).pipe(take(1)).toPromise();

    }
}
